/* eslint-disable arrow-body-style  */
import { getBudgetService } from '../../services/yclickMaster';
import {
  getMultipleDraft as getMultipleDraftService,
  deleteDraft as deleteDraftService,
  postCreateMultipleServiceRequest as postCreateMultipleServicerequestService,
  updateMultipleDraft as updateMultipleDraftService
} from '../../services/serviceRequest';
import {
  getTemplateRequest,
  replicateTemplateRequest
} from '../../services/templateServiceRequest';
import { imputationTypeEnum, ubicationTypeEnum } from '../../utils/dataStatus';

import {
  draftResponseAdapter,
  createMultipleServiceRequestAdapter
} from './createServiceRequestUtils';

const postCreateMultipleRequest = async (
  params,
  deletedServices,
  idSDSToReply,
  isApplyTemplateRequest
) => {
  const paramsAfter = createMultipleServiceRequestAdapter(
    params,
    deletedServices,
    idSDSToReply,
    isApplyTemplateRequest
  );
  const response = await postCreateMultipleServicerequestService(paramsAfter);

  return response;
};

// isDraw solo se agrega si vamos a generar una plantilla a partir de un borrador
// Si es la vista del borrador normal no necesitamos pasarle isDraw
// isEditTemplate sirve para cuando estamos editando un template, pero tambien nos va a servir
// para cuando apliquemos una plantilla, ya que vamos a hacer el fetch de los datos de la plantilla
const getMultipleDraft = async (
  id,
  isReplyRequest = false,
  isEditTemplate = false,
  isDraw = false,
  isApplyTemplateRequest = false
) => {
  try {
    let data;

    if (!isReplyRequest && !isEditTemplate && !isApplyTemplateRequest) {
      data = await getMultipleDraftService(id);
    } else if (!isEditTemplate && isReplyRequest) {
      data = await replicateTemplateRequest(id);
    } else if (isEditTemplate || isApplyTemplateRequest) {
      data = await getTemplateRequest(id);
    }
    const isOyM =
      data?.ubicacion?.tipoUbicacion?.id !== ubicationTypeEnum.pozo &&
      data?.ubicacion?.tipoUbicacion?.id !== ubicationTypeEnum.locacion;

    const resBudget = await Promise.all(
      data?.ubicacion?.pozos?.map((pozo) =>
        pozo.tipoImputacion.id === imputationTypeEnum.PEP
          ? getBudgetService(pozo.objetoImputacion.id)
          : null
      )
    ).catch(() => []);

    return draftResponseAdapter(
      data,
      resBudget,
      isReplyRequest,
      isEditTemplate,
      isDraw,
      isApplyTemplateRequest,
      isOyM
    );
  } catch (err) {
    throw new Error(err?.message);
  }
};

// DELETE Draft

const deleteDraft = async (id) =>
  new Promise((resolve, reject) => {
    deleteDraftService(id)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });

const updateMultipleDraft = (gsdsNumber, params, deletedServices = []) => {
  const paramsAfter = createMultipleServiceRequestAdapter(params, deletedServices);

  return updateMultipleDraftService(gsdsNumber, paramsAfter);
};

/**
 * @param {{data: {id: number, nombre: string}[], statusCode: number, message: string}} data
 * @returns {{id: number, label: string, nombre: string, value: number}[]}
 */
export const getInspectorsAdapter = ({ data }) => {
  return data.map((inspector) => ({
    ...inspector,
    label: inspector.nombre,
    value: inspector.id
  }));
};

export {
  deleteDraft,
  // getDraft,
  getMultipleDraft,
  postCreateMultipleRequest,
  // updateDraft
  updateMultipleDraft
};
